module.exports = __webpack_public_path__ + "static/img/pick-up-arrow.869e6f8.svg";